function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgPrescriptionRefill = function SvgPrescriptionRefill(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement(Path, {
    stroke: props.fillLine,
    d: "m9.184 8.915 5.9 5.901m-2.961 2.962 5.655-5.655a4.172 4.172 0 1 0-5.9-5.9l-5.656 5.654a4.172 4.172 0 1 0 5.9 5.9Z"
  }));
};
export default SvgPrescriptionRefill;